import * as types from 'apa/actions/types'

export function apiAction({
  url = '',
  method = 'GET',
  data = null,
  onSuccess = () => ({type: 'NO'}),
  onFailure = () => ({type: 'NO'}),
  label = '',
  needsToken = true
}) {
  return {
    type: types.API_CALL,
    payload: {
      url,
      method,
      data,
      onSuccess,
      onFailure,
      label,
      needsToken
    }
  };
}

export const sendMessage = (message) => ({
    type: types.NEW_MESSAGE,
    message: message
})


export const apiStart = (label) => ({
  type: types.API_START,
  payload: label
})


export const apiEnd = (label) => ({
  type: types.API_END,
  payload: label
})

export const apiError = (errors) => ({
  type: types.API_ERROR,
  errors
})

export const parseError = (errors) => ({
  type: types.PARSE_ERROR,
  errors
})

export const apiSuccess = () => ({
  type: types.API_SUCCESS,
})

export const accessDenied = (url) => ({
    type: types.API_ACCESS_DENIED,
    payload: url
  }
)

export const loadUser = () => dispatch => {
    dispatch({
      type: types.USER_LOADING
    })
    dispatch(apiAction(
      { 
        url: 'https://apabackend.quixtest.de/api/auth/user/',
        onSuccess: (data) => ({ type: types.USER_LOADED, user: data }),
        onFailure: (errors) => ({ type: types.USER_LOADED_ERROR, errors: errors }),
      }
    ))
}

export const cancelLoad = () => dispatch => dispatch({type: types.CANCEL_USER_LOAD})

export const login = (username, password) => dispatch => dispatch(
  apiAction(
      { 
        url: 'https://apabackend.quixtest.de/api/auth/login/',
        onSuccess: (data) => ({ type: types.LOGIN_SUCCESSFUL, data: data }),
        onFailure: (errors) => ({ type: types.LOGIN_FAILED, errors: errors }),
        data: { username: username, password: password },
        method: 'POST',
        needsToken: false
      }
    ))

export const signup = (data) => dispatch => dispatch(
    apiAction(
        {
            url: 'https://apabackend.quixtest.de/api/auth/signup/',
            onSuccess: (data) => ({ type: types.LOGIN_SUCCESSFUL, data: data }),
            onFailure: (errors) => ({ type: types.LOGIN_FAILED, errors: errors }),
            data: data,
            method: 'POST',
            needsToken: false
        }
    ))

export const logout = () => dispatch => dispatch(
  apiAction(
    {
      url: 'https://apabackend.quixtest.de/api/auth/logout/',
      method: 'POST',
      body: {},
      onSuccess: () => ({ type: types.LOGOUT_SUCCESSFUL }),
      onFailure: (errors) => ({ type: types.AUTHENTICATION_ERROR, errors: errors })
    }
  ))
